import eventFieldService from "@/api/eventModule/eventFieldServices";

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) =>
      eventFieldService
        .loadTable(pageConfig)
        .then((result) => {
          commit("LOAD_LIST_EVENT_FIELDS", result.data.content);
          resolve(result);
        })
        .catch((err) => reject(err))
    );
  },
  insertNewEventField({ commit }, data) {
    return eventFieldService
      .insertNewEventField(data)
      .then((result) => result)
      .catch((error) => error);
  },
  prepareToEditEventField({ commit }, data) {
    commit("PREPARE_TO_EDIT_EVENT_FIELD", data);
  },
  editEventField({ commit }, data) {
    return eventFieldService
      .editEventField(data)
      .then((result) => result)
      .catch((error) => error);
  },
  resetEventField({ commit }) {
    commit("RESET_EVENT_FIELD");
  },
  delete({ commit }, id) {
    return eventFieldService
      .deleteEventField(id)
      .then((result) => result)
      .catch((error) => error);
  },
};
